/**
 * This will work as a default slider where depending on the breakpoints, the content will overflow the container.
 *
 * Be sure to include the components-default-slider.css and add the default-slider class to the section.
 * Also be sure to include the slide classes from _cls.scss, so swiper-container--2-slides, swiper-container--md-3-slides, etc.
 *
 * Html markup:
 * <div class="default-slider__swiper swiper-container swiper-container--2-slides swiper-container--md-3-slides swiper-container--lg-4-slides">
    <div class="swiper swiper-container" data-default-slider>

      {%- comment -%} Swiper header {%- endcomment -%}
      <div class="default-slider__header-wrapper is-flex is-justified-space-between is-aligned-center">

        Optional title goes here

        {%- comment -%} Swiper navigation {%- endcomment -%}
        {%- if section.settings.swiper_navigation -%}
          <div class="swiper-navigation swiper-navigation--custom">
            <button class="swiper-button-prev swiper-button-prev-{{ section.id }} swiper-button-prev--full" aria-label="{% render "format-translation", namespace: "accessibility", key: "next_slide", fallback: "Next slide" %}">
              {%- render 'global-icon', icon: 'arrow', icon_size: 'sm' -%}
            </button>
            <button class="swiper-button-next swiper-button-next-{{ section.id }} swiper-button-next--full" aria-label="{% render "format-translation", namespace: "accessibility", key: "previous_slide", fallback: "Previous slide" %}">
              {%- render 'global-icon', icon: 'arrow', icon_size: 'sm' -%}
            </button>
          </div>
        {%- endif -%}
      </div>

      <div class="swiper-wrapper">
        Slides go here
      </div>
    </div>
  </div>

  Add data-options per section, like for example:
    data-options='{
      "speed": {{ section.settings.swiper_speed }},
      "effect":	"{{ section.settings.swiper_effect }}",
      "loop":	{{ section.settings.swiper_loop }},
      {% if section.settings.swiper_autoplay %}
      "autoplay": {
        "delay": {{ section.settings.swiper_autoplay_speed }}
      },
      {% endif %}
      {% if section.settings.swiper_navigation %}
      "navigation": {
        "nextEl": ".swiper-button-next-{{ section.id }}",
        "prevEl": ".swiper-button-prev-{{ section.id }}"
      },
      {% endif %}
      {% if section.settings.swiper_pagination %}
        "pagination": {
          "el": ".swiper-pagination-{{ section.id }}",
          "clickable": true
        },
      {% endif %}
      {% if section.settings.swiper_scrollbar %}
        "scrollbar": {
          "el": ".swiper-scrollbar-{{ section.id }}",
          "draggable": true
        },
      {% endif %}
      "spaceBetween": 10,
      "breakpoints": {
        "375": {
          "slidesPerView": 2
        },
        "768": {
          "slidesPerView": 3.2
        },
        "1024": {
          "slidesPerView": 4,
          "spaceBetween": 30
        },
        "1441": {
          "slidesPerView": 4.2,
          "spaceBetween": 30
        }
      }
    }'
 **/

(async () => {

  if (!customElements.get('default-slider')) {

    const { default: Swiper, Navigation, Pagination, Scrollbar, Autoplay, Grid } = await import("swiper");

    Swiper.use([
      Navigation,
      Pagination,
      Scrollbar,
      Autoplay,
      Grid
    ]);

    class DefaultSlider extends HTMLElement {
      constructor() {
        super();
        this.swiperElement = this.querySelector('[data-default-slider]');
        this.swiperOptions = {
          observer: true,
          threshold: 10,
          on: {
            resize: function (swiper) {
              swiper.update();
            },
          },
        }

        // Check if we have extra options on the HTML
        if (this && this.dataset && this.dataset.options) {
          const jsonOptions = JSON.parse(this.dataset.options);
          if (jsonOptions) {
            this.swiperOptions = {
              ...this.swiperOptions,
              ...jsonOptions
            };
          }
        }

        // re-init slider when Theme Editor is active
        if (Shopify.designMode && this.swiperInstance) {
          window.addEventListener('shopify:section:load', () => {
            this.swiperInstance.update();
          });
        }
        this.init();
      }

      init() {
        this.swiperInstance = new Swiper(this.swiperElement, this.swiperOptions);
        // remove class with CLS preventive style (currently used for the tags in the collection banner with image & blog tags in the page blog-landing)
        if (this.classList.contains('prevent-tag-slider-cls')) this.classList.remove('prevent-tag-slider-cls');
      }

    }
    window.DefaultSlider = DefaultSlider;
    customElements.define('default-slider', DefaultSlider);
  }

})();
